import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "search-vocabularies" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = ["aria-pressed"]
const _hoisted_4 = {
  class: "h-3 w-3",
  focusable: "false",
  "aria-hidden": "true",
  width: "12",
  height: "12"
}
const _hoisted_5 = ["aria-pressed"]
const _hoisted_6 = {
  key: 0,
  width: "13",
  height: "13",
  class: "ml-2",
  focusable: "false",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "ml-auto mr-2 text-ccc" }
const _hoisted_8 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_filter_vocabulary_component = _resolveComponent("filter-vocabulary-component", true)!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.vocabulary.leaf)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "search-toggle-sm",
            "aria-pressed": _ctx.isExpanded ? 'true' : 'false',
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleChildren && _ctx.toggleChildren(...args)))
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_4, [
              _createElementVNode("use", _normalizeProps(_guardReactiveProps({ 'xlink:href': '#arrow-down' })), null, 16)
            ]))
          ], 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: _normalizeClass(["flex w-full items-center py-4 text-left leading-none", {
          'ml-8': _ctx.vocabulary.leaf,
          'font-bold': _ctx.isActive,
        }]),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleVocabulary && _ctx.toggleVocabulary(...args))),
        "aria-pressed": _ctx.isActive ? 'true' : 'false'
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.vocabulary.text), 1),
        (_ctx.isActive)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_6, [
              _createElementVNode("use", _normalizeProps(_guardReactiveProps({ 'xlink:href': '#close' })), null, 16)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.vocabulary.count), 1)
      ], 10, _hoisted_5)
    ]),
    (_ctx.isExpanded && _ctx.vocabulary.children && _ctx.vocabulary.children.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vocabulary.children, (child) => {
            return (_openBlock(), _createBlock(_component_filter_vocabulary_component, {
              key: `${_ctx.kind}-${child.id}`,
              kind: _ctx.kind,
              vocabulary: child,
              "expanded-items": _ctx.expandedItems,
              onExpandChildren: _ctx.emitExpandChildren,
              "aria-role": "treeitem"
            }, null, 8, ["kind", "vocabulary", "expanded-items", "onExpandChildren"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}